module.exports = __webpack_public_path__ + "img/UTGREA-7.1bacfd03.jpg";